<template>
	<div>
		<div v-if="!isIframe">
			<span
			>{{ this.$t("share.url") }} | <a class="pointer" @click.prevent="copyGameLink">{{ this.$t("generics.copy") }}</a></span
			>
			<v-alert
				color="cyan"
				border="left"
				elevation="2"
				colored-border
				icon="share"
				class="text-left"
			>
				<a :href="game.link" target="blank">
					{{ game.link }}
				</a>
			</v-alert>
		</div>
		<div v-else>
			<span
			>{{ this.$t("share.embed") }} |
				<a class="pointer" @click.prevent="copyIframeLink">{{ this.$t("generics.copy") }}</a></span
				>
			<v-alert
				color="cyan"
				border="left"
				elevation="2"
				colored-border
				icon="share"
				class="text-left"

			>
				<div style="direction: ltr" > {{ iframeLink }} </div>
			</v-alert>
		</div>
	</div>
</template>

<script>
import * as clipboard from "clipboard-polyfill/text";
export default {
	name: "ShareLink",
	components: {},
	props: {
		game: {
			type: Object,
			required: true
		},
		isIframe: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			model: true
		};
	},
	computed: {
		iframeLink() {
			return `<iframe width='100%' height='100%' src='${this.game.link}?embed' scrolling="no" allowfullscreen></iframe>`;
		}
	},
	methods: {
		copyGameLink() {
			clipboard.writeText(this.game.link);
			this.$notification.success(this.$t("share.url_copy_success"));
		},
		copyIframeLink() {
			clipboard.writeText(this.iframeLink);
			this.$notification.success(this.$t("share.embed_copy_success"));
		}
	}
};
</script>

<style scoped></style>
